import { render, staticRenderFns } from "./SurveyCategoryCheck.vue?vue&type=template&id=32789bbc&"
import script from "./SurveyCategoryCheck.vue?vue&type=script&lang=js&"
export * from "./SurveyCategoryCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports